export default __webpack_public_path__ + "static/media/mysql.1977a7c1.png";